/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Rose_CaptionInputs */

const en_ui_weather_rose_caption = /** @type {(inputs: Ui_Weather_Rose_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where the wind came from, relative to your direction of travel. Longer sectors mean more of your moving time.`)
};

const de_ui_weather_rose_caption = /** @type {(inputs: Ui_Weather_Rose_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woher der Wind kam — relativ zu deiner Bewegungsrichtung. Längere Sektoren heißen mehr Bewegungszeit.`)
};

/**
* | output |
* | --- |
* | "Where the wind came from, relative to your direction of travel. Longer sectors mean more of your moving time." |
*
* @param {Ui_Weather_Rose_CaptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_rose_caption = /** @type {((inputs?: Ui_Weather_Rose_CaptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Rose_CaptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_rose_caption(inputs)
	return de_ui_weather_rose_caption(inputs)
});